import DtoHydrometryObservation from 'hydrometry/dto/DtoHydrometryObservation'
import { compact, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getDate } from '../../../../utils/DateUtil'
import { arrayOf } from '../../../../utils/StoreUtils'
import HydrometryAction from '../../../actions/HydrometryAction'
import DtoHydroStats from '../../../dto/chronicMeasures/DtoHydroStats'
import { Card, Grid, Tooltip } from '@mui/material'
import TideGaugeDetails from './TideGaugeDetails'
import DtoHydrometricStation from '../../../dto/DtoHydrometricStation'
import { NewTable } from '../../../../components/datatable/NewTable'
import InfoIcon from '@mui/icons-material/Info'
import { STATION_TYPE_CONSTANT } from '../../../../station/constants/StationConstants'

class HydroStatisticsPanel extends Component {
    componentDidMount() {
        // this.props.fetchHydroStatistics(parseInt(this.props.id)) --> call djà fait dans le HydroChartPanel
    }

    getMeasureFormat = () => {
        const { hydroStatistics, hydrometryObservations } = this.props
        const stats = orderBy(hydroStatistics, ['order', 'typeId'], 'asc').map(p => {
            const comment = p?.comment ? (
                <Tooltip title={ p.comment}>
                    <InfoIcon
                        style={{ fontSize: 18, color: 'grey' } }
                    />
                </Tooltip>) : ''
            return {
                label: { value: <Grid container spacing={1} fontWeight={'bold'} alignItems={'center'}>{p.label} {comment}</Grid>, sortValue: p.label },
                isMultiPoint: p.namePoint,
                startDate: getDate(p.startDate),
                endDate: getDate(p.endDate),
                countTotal: p.countTotal,
                control: getDate(p.control),
                validation: getDate(p.validation),
            }
        })
        if (hydrometryObservations.length) {
            const allHydroObsDate = compact(hydrometryObservations.map(o => o.observationDate))
            const statsObs = {
                label: <Grid fontWeight={'bold'}>{i18n.observations}</Grid>,
                startDate: getDate(Math.min(...allHydroObsDate)),
                endDate: getDate(Math.max(...allHydroObsDate)),
                countTotal: hydrometryObservations.length,
            }
            return [...stats, statsObs]
        }
        return stats
    }

    getBody = () => {
        const statistics = this.getMeasureFormat()
        const headers = [
            { key: 'label', value: i18n.statistics },
            { key: 'isMultiPoint', value: i18n.pointPrelevement },
            { key: 'startDate', value: i18n.begin },
            { key: 'endDate', value: i18n.end },
            { key: 'countTotal', value: i18n.nbMeasures },
            { key: 'control', value: i18n.control },
            { key: 'validation', value: i18n.validationDate },
        ].filter(s => !!s)

        return (
            <>
                <NewTable
                    rows={statistics}
                    rowsPerPageOptions={-1}
                    headers={headers}
                />
            </>
        )
    }

    render() {
        const { id, hydrometricStation } = this.props
        const content = (
            <Grid container>
                <Grid size={12} sx={{ padding: 0 }}>
                    {this.getBody()}
                </Grid>
            </Grid>
        )
        return (
            <>
                <Card sx={{ border: '1px solid grey', borderRadius: '5px', width: '100%', boxShadow: 'none' }}>
                    { content }
                </Card>
                {
                    hydrometricStation.stationType === STATION_TYPE_CONSTANT.HYDROMETRY && (
                        <Grid marginTop={1}>
                            <TideGaugeDetails stationId={parseInt(id)}/>
                        </Grid>
                    )
                }
            </>
        )
    }
}

HydroStatisticsPanel.propTypes = {
    hydrometricStation: PropTypes.instanceOf(DtoHydrometricStation),
    hydroStatistics: arrayOf(DtoHydroStats),
    hydrometryObservations: arrayOf(DtoHydrometryObservation),
    fetchHydroStatistics: PropTypes.func,
    id: PropTypes.string.isRequired,
}

const mapStateToProps = store => ({
    hydrometricStation: store.HydrometryReducer.hydrometricStation,
    hydroStatistics: store.HydrometryReducer.hydroStatistics,
    hydrometryObservations: store.HydrometryReducer.hydrometryObservations,
})

const mapDispatchToProps = {
    fetchHydroStatistics: HydrometryAction.fetchHydroStatistics,
}

export default connect(mapStateToProps, mapDispatchToProps)(HydroStatisticsPanel)
